var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 192H144V128C144 83.891 179.891 48 224 48C258.844 48 289.438 70.25 300.141 103.375C304.234 116 317.672 122.859 330.359 118.844C342.969 114.766 349.891 101.234 345.828 88.625C328.688 35.609 279.734 0 224 0C153.422 0 96 57.422 96 128V192H64C28.654 192 0 220.654 0 256V448C0 483.346 28.654 512 64 512H384C419.346 512 448 483.346 448 448V256C448 220.654 419.346 192 384 192ZM400 448C400 456.822 392.822 464 384 464H64C55.178 464 48 456.822 48 448V256C48 247.178 55.178 240 64 240H384C392.822 240 400 247.178 400 256V448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.c17ad368247b37199f09a741aaf1d4e4.svg";
export { ForwardRef as ReactComponent };